module.exports = __webpack_public_path__ + "images/product-navigation/accessories-b22454c3.svg";